import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, cloneElement } from "react";
import { useTheme, FormControlLabel, Stack, Box } from "@mui/material";
import { useThemeColor } from "../../../themes/hooks/useThemeColor.es.js";
import { isSuperFormControlLabel } from "../utils.es.js";
import EzSuperFormControlLabel from "../../EzSuperFormControlLabel/EzSuperFormControlLabel.es.js";
const EzFormControlLabelMui = forwardRef((props, ref) => {
  const { checked, control, disabled, label, value } = props;
  const theme = useTheme();
  const themeColor = useThemeColor(control.props.color || "primary");
  if (isSuperFormControlLabel(props)) {
    return /* @__PURE__ */ jsx(
      EzSuperFormControlLabel,
      {
        ref,
        checked,
        control: cloneElement(control, { ariaLabel: control.props.ariaLabel || null }),
        disabled,
        icon: props.icon,
        label,
        value
      }
    );
  }
  const { labelIcons, helperText, ...remainingProps } = props;
  return /* @__PURE__ */ jsx(
    FormControlLabel,
    {
      inputRef: ref,
      checked,
      classes: { root: "EzFormControlLabel", label: "EzFormControlLabel-label" },
      control: cloneElement(control, { ariaLabel: control.props.ariaLabel || null }),
      disabled,
      ...remainingProps,
      label: /* @__PURE__ */ jsxs(Stack, { children: [
        /* @__PURE__ */ jsxs(Stack, { direction: "row", children: [
          label,
          labelIcons == null ? void 0 : labelIcons.map((labelIcon, index) => /* @__PURE__ */ jsx(Box, { ml: 1, children: labelIcon }, index))
        ] }),
        helperText && /* @__PURE__ */ jsx(
          Box,
          {
            className: "EzFormControlLabel-helperText",
            color: theme.palette.common.grey150,
            fontSize: "12px",
            children: helperText
          }
        )
      ] }),
      sx: {
        alignItems: "start",
        ml: "-7px",
        ".EzFormControlLabel-label": {
          ml: "5px",
          mt: "5px"
        },
        "&:hover .EzRadioIcon-unchecked": {
          bgcolor: disabled ? void 0 : themeColor,
          borderColor: disabled ? void 0 : themeColor
        }
      }
    }
  );
});
EzFormControlLabelMui.displayName = "EzFormControlLabelMui";
export {
  EzFormControlLabelMui as default
};
//# sourceMappingURL=EzFormControlLabelMui.es.js.map
